module.exports = __webpack_public_path__ + "static/img/funny_14.b3298eaf.jpg";